import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { CATALOG_URL, waLink } from '@/config/site';

const recursos = [
  {
    icon: 'ri-layout-masonry-line',
    title: 'Curadoria por ambiente',
    text: 'Estações, salas de reunião, recepção, diretoria e auditório organizados por uso real.',
  },
  {
    icon: 'ri-ruler-2-line',
    title: 'Ficha técnica',
    text: 'Medidas, materiais, acabamentos e opções de configuração de cada item.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Lista de interesse',
    text: 'Monte a relação dos itens do projeto e envie para a equipe comercial.',
  },
  {
    icon: 'ri-user-shared-line',
    title: 'Área do cliente',
    text: 'Cada empresa acessa apenas os próprios dados, pedidos e atendimentos.',
  },
];

const categorias = [
  { icon: 'ri-armchair-line', title: 'Cadeiras corporativas', text: 'Operação, atendimento, diretoria e ergonômicas.', to: '/cadeiras', msg: 'cadeiras' as const },
  { icon: 'ri-layout-4-line', title: 'Mesas e estações', text: 'Estações de trabalho, reunião e apoio.', to: '/mesas', msg: 'mesas' as const },
  { icon: 'ri-archive-2-line', title: 'Móveis de aço', text: 'Armários, arquivos, gaveteiros e vestiários.', to: '/aco', msg: 'projetos' as const },
  { icon: 'ri-layout-column-line', title: 'Divisórias', text: 'Modulares, sanitárias e ambientes corporativos.', to: '/divisorias', msg: 'projetos' as const },
  { icon: 'ri-volume-mute-line', title: 'Cabines acústicas', text: 'Reuniões, ligações e trabalho concentrado.', to: '/cabines-acusticas', msg: 'projetos' as const },
  { icon: 'ri-hotel-bed-line', title: 'Poltronas para auditório', text: 'Auditórios, igrejas e eventos.', to: '/projetos-corporativos', msg: 'auditorio' as const },
  { icon: 'ri-school-line', title: 'Mobiliário escolar', text: 'Conjuntos aluno e professor, refeitório e biblioteca.', to: '/escolar', msg: 'projetos' as const },
  { icon: 'ri-pencil-ruler-2-line', title: 'Marcenaria sob medida', text: 'Balcões, painéis e mobiliário planejado.', to: '/marcenaria-corporativa', msg: 'projetos' as const },
];

const passos = [
  { number: '01', title: 'Acesse o catálogo', text: 'Entre com a sua conta ou crie um cadastro na própria tela do catálogo.' },
  { number: '02', title: 'Explore as soluções', text: 'Navegue por categorias, veja fichas técnicas e monte a lista do ambiente.' },
  { number: '03', title: 'Fale com a equipe', text: 'Envie a lista e receba a proposta com prazo, entrega e montagem.' },
];

export default function CatalogoPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-14 md:pt-16">
        {/* Hero */}
        <section className="bg-white">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10 pt-10 md:pt-16 pb-12 md:pb-16">
            <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-2 text-[11.5px] text-foreground-400 mb-7">
              <Link to="/" className="hover:text-foreground-950 transition-colors whitespace-nowrap">Home</Link>
              <i className="ri-arrow-right-s-line text-foreground-300"></i>
              <span className="text-foreground-700 whitespace-nowrap">Catálogo</span>
            </nav>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center">
              <div className="lg:col-span-5">
                <p className="hop-eyebrow text-foreground-400">Catálogo interativo</p>

                <h1 className="mt-5 text-[34px] sm:text-[44px] md:text-[52px] leading-[1.05] tracking-[-0.038em] font-semibold text-foreground-950">
                  A seleção completa, organizada por ambiente.
                </h1>

                <p className="mt-5 text-[15px] md:text-[16.5px] leading-[1.6] text-foreground-500 max-w-[520px]">
                  Uma curadoria técnica com ficha de cada item, medidas e configurações —
                  para especificar com segurança e comparar alternativas.
                </p>

                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  <a
                    href={CATALOG_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 bg-foreground-950 text-white text-[14px] md:text-[15px] font-medium px-7 py-3.5 rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Acessar catálogo
                    <i className="ri-arrow-right-up-line text-[13px]"></i>
                  </a>
                  <Link
                    to="/contato"
                    className="inline-flex items-center justify-center border border-background-300 text-foreground-800 text-[14px] md:text-[15px] font-medium px-7 py-3.5 rounded-full hover:border-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Solicitar atendimento
                  </Link>
                </div>

                <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-[12.5px]">
                  <a
                    href={CATALOG_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-login-circle-line text-sm"></i>
                    Entrar na minha conta
                  </a>
                  <span className="hidden sm:inline h-3 w-px bg-background-300" />
                  <a
                    href={CATALOG_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-user-add-line text-sm"></i>
                    Criar conta
                  </a>
                </div>

                <p className="mt-6 text-[11.5px] text-foreground-400 leading-relaxed max-w-[420px]">
                  O acesso, o cadastro e o histórico de pedidos permanecem na plataforma do catálogo.
                  Nenhum dado de cliente ou preço restrito é exibido nesta página pública.
                </p>
              </div>

              <div className="lg:col-span-7">
                <div className="w-full h-[260px] sm:h-[340px] lg:h-[440px] rounded-[18px] md:rounded-[24px] overflow-hidden bg-background-100">
                  <img
                    src="/media/ia/0194.webp"
                    alt="Catálogo interativo de móveis corporativos da Home Office Premium"
                    title="Catálogo interativo de móveis corporativos — Home Office Premium"
                    className="w-full h-full object-cover object-center"
                    fetchPriority="high"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Recursos */}
        <section className="border-y border-background-200 bg-background-50">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
              {recursos.map((item, index) => (
                <div
                  key={item.title}
                  className={`py-6 md:py-8 ${
                    index > 0 ? 'border-t sm:border-t-0 sm:border-l border-background-200 sm:pl-6 lg:pl-8' : 'sm:pr-6 lg:pr-8'
                  }`}
                >
                  <i className={`${item.icon} text-[17px] text-primary-600`}></i>
                  <h2 className="mt-3 text-[14px] md:text-[15px] font-medium text-foreground-950 tracking-[-0.02em]">{item.title}</h2>
                  <p className="mt-1.5 text-[12.5px] text-foreground-500 leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Categorias */}
        <section className="hop-section bg-white">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <h2 className="text-[26px] sm:text-[32px] md:text-[40px] leading-[1.08] tracking-[-0.035em] font-semibold text-foreground-950 max-w-[520px]">
                As linhas que trabalhamos.
              </h2>
              <p className="text-[13px] text-foreground-400 max-w-[320px] leading-relaxed">
                Cada categoria tem a versão completa dentro do catálogo, com opções e medidas.
              </p>
            </div>

            <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 border-t border-background-200">
              {categorias.map((cat) => (
                <div key={cat.title} className="flex flex-col py-6 border-b border-background-200">
                  <i className={`${cat.icon} text-[17px] text-foreground-400`}></i>
                  <h3 className="mt-4 text-[15px] font-medium text-foreground-950 tracking-[-0.02em]">{cat.title}</h3>
                  <p className="mt-1.5 text-[12.5px] text-foreground-500 leading-relaxed flex-1">{cat.text}</p>
                  <div className="mt-4 flex flex-wrap items-center gap-4">
                    <Link
                      to={cat.to}
                      className="inline-flex items-center gap-1 text-[12px] font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Ver no site
                      <i className="ri-arrow-right-line text-[11px]"></i>
                    </Link>
                    <a
                      href={waLink(cat.msg)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-[12px] font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-whatsapp-line text-[12px]"></i>
                      Consultar
                    </a>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-col sm:flex-row sm:items-center justify-between gap-5 border-t border-background-200 pt-6">
              <div>
                <p className="text-[14px] font-medium text-foreground-950">Procurando algo que não está na lista?</p>
                <p className="text-[12.5px] text-foreground-500 mt-1">
                  Trabalhamos com projetos completos e mobiliário sob medida para ambientes específicos.
                </p>
              </div>
              <a
                href={waLink('projetos')}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-foreground-950 text-white text-[13px] font-medium px-6 py-3 rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer flex-shrink-0"
              >
                <i className="ri-whatsapp-line text-base"></i>
                Falar sobre meu projeto
              </a>
            </div>
          </div>
        </section>

        {/* Passos */}
        <section className="hop-section bg-background-50 border-t border-background-200">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
              <div className="lg:col-span-4">
                <p className="hop-eyebrow text-foreground-400">Como funciona</p>
                <h2 className="mt-4 text-[26px] sm:text-[32px] md:text-[38px] leading-[1.08] tracking-[-0.035em] font-semibold text-foreground-950">
                  Três passos até a proposta.
                </h2>
              </div>
              <div className="lg:col-span-8">
                <div className="border-t border-background-200">
                  {passos.map((passo) => (
                    <div key={passo.number} className="flex items-start gap-5 py-6 border-b border-background-200">
                      <span className="text-[11px] font-medium tracking-[0.14em] text-foreground-300 pt-1 w-7 flex-shrink-0">
                        {passo.number}
                      </span>
                      <div>
                        <h3 className="text-[15px] md:text-[16px] font-medium text-foreground-950 tracking-[-0.02em]">{passo.title}</h3>
                        <p className="mt-1.5 text-[13px] text-foreground-500 leading-relaxed max-w-[460px]">{passo.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Privacidade */}
        <section className="bg-white py-12 md:py-16">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-5 border-t border-background-200 pt-6">
              <div className="flex items-start gap-3.5">
                <i className="ri-shield-check-line text-[17px] text-foreground-400 mt-0.5"></i>
                <div>
                  <h2 className="text-[15px] font-medium text-foreground-950 tracking-[-0.02em]">Seus dados ficam protegidos</h2>
                  <p className="mt-1.5 text-[12.5px] text-foreground-500 leading-relaxed max-w-[620px]">
                    A área da conta, os pedidos e as informações cadastrais são privados e tratados conforme a LGPD.
                    Nesta página pública não exibimos preços restritos, dados de clientes ou pedidos.
                  </p>
                </div>
              </div>
              <Link
                to="/privacidade"
                className="inline-flex items-center justify-center border border-background-300 text-foreground-800 text-[13px] font-medium px-6 py-3 rounded-full hover:border-foreground-950 transition-colors whitespace-nowrap cursor-pointer flex-shrink-0"
              >
                Política de Privacidade
              </Link>
            </div>
          </div>
        </section>

        {/* CTA final */}
        <section className="pb-20 md:pb-28">
          <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10">
            <div className="rounded-[20px] md:rounded-[28px] bg-background-950 px-6 sm:px-10 md:px-16 py-12 md:py-16 text-center">
              <h2 className="text-[26px] sm:text-[32px] md:text-[40px] leading-[1.1] tracking-[-0.038em] font-semibold text-white max-w-[560px] mx-auto">
                Pronto para montar o seu ambiente?
              </h2>
              <p className="mt-4 text-[14px] md:text-[15px] text-white/55 max-w-[460px] mx-auto leading-relaxed">
                Acesse o catálogo interativo ou fale com a equipe comercial.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href={CATALOG_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-white text-foreground-950 text-[14px] font-medium px-7 py-3.5 rounded-full hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Acessar catálogo
                  <i className="ri-arrow-right-up-line text-[13px]"></i>
                </a>
                <a
                  href={waLink('catalogo')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 border border-white/20 text-white text-[14px] font-medium px-7 py-3.5 rounded-full hover:border-white/50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}